/**
 * @generated SignedSource<<3aed7ae9848d0036729fb9f74b434dfc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LabelDropdown_labels$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string | null;
  readonly color: string | null;
  readonly category: {
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly " $fragmentType": "LabelDropdown_labels";
}>;
export type LabelDropdown_labels$key = ReadonlyArray<{
  readonly " $data"?: LabelDropdown_labels$data;
  readonly " $fragmentSpreads": FragmentRefs<"LabelDropdown_labels">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "LabelDropdown_labels",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LabelCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Label",
  "abstractKey": null
};
})();

(node as any).hash = "9613be95dae981f8f5934ef8adc95529";

export default node;
